import Subtitle from '@components/atoms/texts/subtitle';
import Title from '@components/atoms/texts/title';
import { color, COLORS } from '@helpers/constants';
import { Button, Icon } from '@minds/minds-react-sdk';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import style from './access-denied-content.module.scss';

interface Props {
    modularProductPermission?: boolean;
    homePath?: string;
}

export default function AccessDeniedContent({
    modularProductPermission,
    homePath,
}: Props) {
    const { t } = useTranslation('accessDenied');

    return (
        <div className="text-center flex justify-center flex-col items-center gap-4 h-85vh">
            {modularProductPermission ? (
                <Icon
                    className={style.lockIcon}
                    name="i-ph-user-focus-duotone"
                    color={color('blue-900')}
                />
            ) : (
                <Icon
                    className={style.lockIcon}
                    name="i-ph-lock-key-fill"
                    color={color('blue-900')}
                />
            )}

            <Title>
                {modularProductPermission
                    ? t('modularProductAccessDeniedTitle')
                    : t('accessDenied')}
            </Title>

            <Subtitle color={COLORS.defaultGray} className="max-w-140">
                {modularProductPermission
                    ? t('modularProductAccessDeniedMessage')
                    : t('accessDeniedMessage')}
            </Subtitle>

            {homePath ? (
                <Link
                    className="flex justify-center decoration-none mt-5"
                    to={homePath}
                >
                    <Button
                        left={
                            <Icon
                                className="me-2 group-hover:bg-gray-800!"
                                name="i-ph-house"
                                size="lg"
                                color="lighter-text"
                            />
                        }
                        content={t('backToHome')}
                        className="px-5 fw-bold group flex justify-center items-center"
                    />
                </Link>
            ) : null}
        </div>
    );
}